import { z } from 'zod';

export const birthDateSchema = z
  .string()
  .max(40)
  .refine((value) => {
    if (!/^\d{4}-\d{2}-\d{2}(?:T.*)?$/.test(value)) return false;
    const date = new Date(value);
    const day = value.slice(0, 10);
    const calendarDate = new Date(`${day}T00:00:00Z`);
    return (
      !Number.isNaN(date.getTime()) &&
      calendarDate.toISOString().slice(0, 10) === day &&
      day >= '1900-01-01' &&
      day <= new Date().toISOString().slice(0, 10)
    );
  }, 'Provide a valid past date of birth');
export const birthTimeSchema = z.string().regex(/^([01]\d|2[0-3]):[0-5]\d$/);
export const birthPlaceSchema = z.string().trim().min(2).max(256);
export const birthTimezoneSchema = z
  .string()
  .max(64)
  .refine((value) => {
    try {
      new Intl.DateTimeFormat('en', { timeZone: value });
      return true;
    } catch {
      return false;
    }
  }, 'Provide a valid IANA timezone');
